import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	ProductChangeRow,
	ProductSizeOption,
} from "../models/ProductChanges";

export interface GetProductChangesParams {
	start: string;
	end: string;
	productSizeId: number | null;
	signal?: AbortSignal;
}

export const getProductChanges = async ({
	start,
	end,
	productSizeId,
	signal,
}: GetProductChangesParams): Promise<ProductChangeRow[]> => {
	const apiService = new MESApiService();
	// Plain dates, no time: the procedure compares them against the billet timestamps
	// without converting either side, exactly as the legacy screen does.
	const parameters: spParameter[] = [
		{ name: "start", value: start },
		{ name: "end", value: end },
		{ name: "productSizeId", value: productSizeId },
	];

	const resp = await apiService.callV2(
		"[MILL].[GetProductChangesReport]",
		parameters,
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching product changes");
	}
	return get(resp, "data.tables[0].rows", []) as ProductChangeRow[];
};

export const getProductChangesPickers = async (
	signal?: AbortSignal,
): Promise<ProductSizeOption[]> => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		"[MILL].[GetProductChangesReportPickers]",
		[],
		signal,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching product sizes");
	}
	return get(resp, "data.tables[0].rows", []) as ProductSizeOption[];
};
